import { render } from "./rqzjTreeDetail.vue?vue&type=template&id=4b679402"
import script from "./rqzjTreeDetail.vue?vue&type=script&lang=js"
export * from "./rqzjTreeDetail.vue?vue&type=script&lang=js"

import "./rqzjTreeDetail.vue?vue&type=style&index=0&id=4b679402&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__